import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Effect } from "./records";

const slice = createEntitySlice<Effect>({ name: "roomEffects" });

export const reducer = slice.reducer;
export const actions = slice.actions;
